export const OfferTypeCode = {
  guaranteedRate: 'GUARANTEED_RATE',
  preApproval: 'PRE_APPROVAL',
};

export const OfferState = {
  matched: 'MATCHED',
  expired: 'EXPIRED',
  new: 'NEW',
  none: 'NONE',
};

export const MatchingState = {
  none: 'NONE',
  primarySso: 'PRIMARY_SSO',
  primaryNonSso: 'PRIMARY_NON_SSO',
  coapplicant: 'COAPPLICANT',
};

export class CustomerOffer {
  constructor(offerTypeCode = null, annualPercentRate = 0.0, financedAmount = 0.0, loanTermNumber = 0, monthlyPaymentAmount = 0.0, isExpired = false, offerState = OfferState.none, promotionalCode = '', cachedTaxId = false, lastFourTax = '') {
    this.offerType = offerTypeCode;
    this.annualPercentRate = annualPercentRate;
    this.financedAmount = financedAmount;
    this.loanTermNumber = loanTermNumber;
    this.monthlyPaymentAmount = monthlyPaymentAmount;
    this.isExpired = isExpired;
    this.offerState = offerState;
    this.promotionalCode = promotionalCode;
    this.cachedTaxId = cachedTaxId;
    this.lastFourTaxId = lastFourTax;
  }

  static isValid(customerOffer) {
    return Object.keys(customerOffer).length > 0 && !!customerOffer.offerType;
  }
}

export class CustomerOfferUpfront {
  constructor(upfrontOffers, customerOffer = null) {
    this.customerOffer = customerOffer;
    this.upfrontOffers = upfrontOffers;
  }
}
